<template>
    <div class="patient-share-header">
        <i class="fa fa-circle" />

        <fertilization-time :hours="hoursSinceFertilization" />

        <div class="v-divider" />

        <treatment-start-date :date="treatment.startDate" />

        <div class="v-divider" />

        <medical-decision-summary :wells="treatment.wells" />

        <b-button class="pink-button" @click="$emit('logout')">{{ $translate('logout') }}</b-button>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import FertilizationTime from '../partials/FertilizationTime'
import TreatmentStartDate from '../partials/TreatmentStartDate'
import MedicalDecisionSummary from '../partials/MedicalDecisionSummary'

export default {
    name: 'PatientShareHeader',
    components: { FertilizationTime, TreatmentStartDate, MedicalDecisionSummary },
    computed: {
        ...mapState({
            treatment: state => state.patient.treatment
        }),
        hoursSinceFertilization() {
            return this.treatment.wells[0].slide.hoursSinceFertilization
        }
    }
}
</script>

<style lang="scss" scoped>
.patient-share-header {
    height: $sub-header-height;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: solid 1px $dark;

    .fa-circle {
        color: $pink;
        margin: 0 0.5rem;
    }

    .pink-button {
        color: $light-3;
        background: $pink-gradient !important;
        margin-left: 3rem;
    }

    .v-divider {
        border-right: solid 0.1rem $dark;
        height: 40%;

        @media screen and #{$new-break2close} {
            padding-left: 0.5rem;
            margin-right: 0.5rem;
        }
        @media screen and #{$new-break3open} {
            padding-left: 1rem;
            margin-right: 1rem;
        }
    }
}
</style>
